export default __webpack_public_path__ + "static/media/home-events-conference-img-06.16f3145f.jpg";